import { useHelmRepoVersions } from '@/react/kubernetes/helm/helmChartSourceQueries/useHelmRepoVersions';
import { ChartReference } from '@/react/kubernetes/helm/types';

export const MSG_CANT_REACH_SOURCE =
  "Portainer can't reach the Helm chart source. Please select a valid helm registry/repository.";

/**
 * Custom hook to check if a chart is reachable
 * Uses the useHelmRepoVersions query to determine if charts can be fetched from the source
 * Although this does take a long time, the cache from useHelmRepoVersions can be reused for loading the available versions
 */
export function useIsChartValid(chartReference?: ChartReference) {
  // use useHelmRepoVersions for the reachability check because the response is cached and reused for loading the available versions
  const isReachableQuery = useHelmRepoVersions(
    {
      staleTime: 0,
      select: (versions) => versions.length > 0,
    },
    chartReference,
    false,
    false
  );

  const { chartPath, repoURL, registryID } = chartReference || {};
  const hasInvalidParams = !chartPath || (!repoURL && !registryID);
  const hasError = hasInvalidParams || isReachableQuery.isError;
  const errorMessage = hasError ? MSG_CANT_REACH_SOURCE : '';

  return {
    isReachable:
      !hasInvalidParams && !isReachableQuery.isError && !!isReachableQuery.data,
    isChecking: isReachableQuery.isInitialLoading,
    hasError: hasInvalidParams || isReachableQuery.isError,
    errorMessage: hasError ? errorMessage : '',
  };
}
